import React, { useMemo } from 'react';
import DmSummary from './DmSummary/DmSummary';
import RsSummary from './RsSummary/RsSummary';
import { checkDeviceLink } from '../Utils/DateFormatter';
import  './DeviceSummary.css';

const DeviceSummary = React.memo (({item, browserTime})=>{
    
  const islink = useMemo(()=>{
    return checkDeviceLink(item?.param_last_date, browserTime) ?  'Online' : 'Offline';
  },[item?.param_last_date])
    
    const type = item?.type || '...';

    return(
    <>
      {(type==="секторная" || type==="круговая") &&
      <DmSummary item={item} islink={islink} browserTime={browserTime} />}
      {type==='RS485'  &&  <RsSummary item={item} islink={islink} browserTime={browserTime} /> } 
    </>
     )
});
// DeviceSummary.displayName = 'DeviceSummary';
export default DeviceSummary;

